import React, { useEffect, useState } from "react";
import axiosInstance from "../api/axiosInstance";

export default function SearchAnalyticsPage() {

  const [topSearches, setTopSearches] = useState([]);
  const [genericSearches, setGenericSearches] = useState([]);
  const [brandedSearches, setBrandedSearches] = useState([]);
const [surgicalSearches, setSurgicalSearches] = useState([]);
const [categorySearches, setCategorySearches] = useState([]);
const [searchHistory, setSearchHistory] = useState([]);
const [noResultSearches, setNoResultSearches] = useState([]);
const [noResultHistory, setNoResultHistory] = useState([]);
  useEffect(() => {

    axiosInstance.get("/top-searches/")
      .then(res => setTopSearches(res.data));

    axiosInstance.get("/generic-searches/")
      .then(res => setGenericSearches(res.data));

    axiosInstance.get("/branded-searches/")
      .then(res => setBrandedSearches(res.data));

axiosInstance.get("/surgical-searches/")
  .then(res => setSurgicalSearches(res.data));

axiosInstance.get("/category-searches/")
  .then(res => setCategorySearches(res.data));

axiosInstance.get("/analytics/search-history/")
  .then(res => setSearchHistory(res.data));

axiosInstance.get("/analytics/no-result-searches/")
  .then(res => setNoResultSearches(res.data));

axiosInstance.get("/analytics/no-result-search-history/")
  .then(res => setNoResultHistory(res.data));
  }, []);

  const renderTable = (title, data) => (
    <div style={styles.card}>
      <h2>{title}</h2>

      <table style={styles.table}>
        <thead>
          <tr>
            <th>Keyword</th>
            <th>Count</th>
          </tr>
        </thead>

        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td>{item.keyword}</td>
              <td>{item.total}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );


const renderSearchHistory = (title, data) => (
  <div style={styles.card}>
    <h2>{title}</h2>

    <table style={styles.table}>
      <thead>
        <tr>
          <th>User</th>
          <th>Phone</th>
          <th>Keyword</th>
          <th>Results</th>
          <th>Date</th>
        </tr>
      </thead>

      <tbody>
        {data.map((item, index) => (
          <tr key={index}>
            <td>{item.user_name}</td>
            <td>{item.phone}</td>
            <td>{item.keyword}</td>
            <td>{item.result_count}</td>
            <td>{new Date(item.created_at).toLocaleString()}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
const deleteAllSearches = async () => {

  if (!window.confirm(
    "Delete all search history?"
  )) return;

  await axiosInstance.delete(
    "/analytics/delete-all-searches/"
  );

  window.location.reload();
};

const renderNoResultHistory = (title, data) => (
  <div style={styles.card}>
    <h2>{title}</h2>

    <table style={styles.table}>
      <thead>

        <tr>
          <th>User</th>
          <th>Phone</th>
          <th>Keyword</th>
          <th>Date</th>

        </tr>
      </thead>

      <tbody>
        {data.map((item, index) => (
          <tr key={index}>
            <td>{item.user_name}</td>
            <td>{item.phone}</td>
            <td>{item.keyword}</td>
            <td>{new Date(item.created_at).toLocaleString()}</td>
          </tr>

        ))}
      </tbody>
    </table>
  </div>
);
  return (



    <div style={styles.container}>

      <h1>Search Analytics</h1>

<button
  onClick={deleteAllSearches}
  style={{
    background: "red",
    color: "white",
    border: "none",
    padding: "10px 15px",
    borderRadius: "8px",
    cursor: "pointer",
    marginBottom: "20px"
  }}
>
  Delete All Searches
</button>

      {renderTable("Top Searches", topSearches)}

      {renderTable("Generic Searches", genericSearches)}

      {renderTable("Branded Searches", brandedSearches)}

{renderTable("No Result Searches", noResultSearches)}


 {renderTable(
  "Surgical Searches",
  surgicalSearches
)}

{renderTable(
  "Category Searches",
  categorySearches
)}

{renderSearchHistory(
  "Search History",
  searchHistory
)}

{renderNoResultHistory(
  "No Result Search History",
  noResultHistory
)}
    </div>
  );
}

const styles = {

  container: {
    padding: "20px",
    background: "#f5f5f5",
    minHeight: "100vh"
  },

  card: {
    background: "#fff",
    padding: "20px",
    borderRadius: "12px",
    marginBottom: "20px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
  },

  table: {
    width: "100%",
    borderCollapse: "collapse"
  }

};